module.exports = __webpack_public_path__ + "img/media (4).d5bcc2d5.png";